<template>
    <div>
        <div class="soft-box" v-if="dataList.length>0">
            <div v-for="(item, index) in dataList" class="soft-item" @click="viewCourse(item)" :key="index">
                <div class="label-box" :style="`background-color: ${filterBgc(item.resType)};`">{{
                    item.resType == 'ppt' ?'课件':item.resType }}</div>
                <div class="dataType" :style="`background-color: ${filterDataType(item.dataType).value};`">{{ filterDataType(item.dataType).label }}</div>
                <el-image :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.resType)" alt=""></el-image>
                <div class="bottom-box">
                    <p v-if="!item.resName">{{ item.resName || '暂无' }}</p>
                    <el-tooltip v-else :disabled="item.resName.length<=15" class="item" effect="dark" :content="item.resName" placement="top-start">
                        <p class="overflow">{{ item.resName || '暂无' }}</p>
                    </el-tooltip>
                    <p v-if="!item.info">{{ item.info || '暂无' }}</p>
                    <el-tooltip v-else :disabled="item.info.length<=15" class="item" effect="dark" :content="item.info" placement="top-start">
                        <p class="overflow">{{ item.info || '暂无' }}</p>
                    </el-tooltip>
                    <div class="banner-box">
                        <div>
                            <el-tooltip class="item" effect="dark" content="点赞次数" placement="top-start">
                                <i class="iconfont icon-dianzan2"></i>
                            </el-tooltip>
                            <div class="item-num">{{ item.likeCount || 0 }}</div>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="浏览次数" placement="top-start">
                                <i class="iconfont icon-icon-" style="font-size: 2.5rem;font-weight: 400;"></i>
                            </el-tooltip>
                            <div class="item-num">{{ item.viewCount || 0 }}</div>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="收藏次数" placement="top-start">
                                <i class="iconfont icon-aixin"></i>
                            </el-tooltip>
                            <div class="item-num">{{ item.collectCount || 0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <no-data style="margin-bottom: 6rem;" v-else></no-data>
    </div>
</template>

<script>
export default {
    props: {
        dataList: {
            require: true,
            default: () => []
        }
    },
    methods: {
        filterBgc(type) {
            var obj = {
                '仿真软件': '#387DFF',
                'ppt': '#FE7C4B',
                '动画': '#D5698A',
                '模型': '#86B9FF',
                '视频': '#555CF7',
                '图片': '#24B89A',
                '试卷': '#EAD656',
                '文档': '#8F98A9'
            }
            return obj[type];
        },
        filterDataType(type){
            var obj={
                0:{
                    label:'云资源',
                    value:'#387DFF'
                },
                1:{
                    label:'校企资源',
                    value:'#FE7C4B'
                },
                2:{
                    label:'本地资源',
                    value:'#D5698A'
                }
            }
            return obj[type]||{};
        },
        /**点击查看课程详情 */
        viewCourse(item) {
            this.$emit('view_detail', item);
        }
    }
}
</script>

<style lang="less" scoped>
.soft-box {
    display: flex;
    flex-wrap: wrap;
    column-gap: 1.5rem;
    row-gap: 4rem;
    .soft-item {
        width: calc((100% - 4.5rem)/4);
        min-width: 31.5rem;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;
        background-color: #ffffff;
        box-shadow: 0px 0px 11.96px 0px rgba(225, 229, 239, 0.50);

        .label-box {
            position: absolute;
            right: 0;
            top: 0;
            width: 8rem;
            height: 3.2rem;
            border-radius: 0px 0px 0px 24px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
        }
        .dataType{
            position: absolute;
            left: 0;
            top: 0;
            // width: 8rem;
            // height: 3.2rem;
            padding: 0.5rem 1rem;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            border-radius: 0.5rem;
            z-index: 99;
        }
        /deep/.el-image {
            width: 100%;
            aspect-ratio: var(--aspectRatio);
            img{    
                width: 100%;
                object-fit: cover;
            }
        }

        .bottom-box {
            padding: 2.5rem 2rem;

            &> :nth-child(1) {
                font-size: 2rem;
                font-weight: 700;
                color: #151C34;
            }

            &> :nth-child(2) {
                margin-top: 1.8rem;
                font-size: 16px;
                color: #9BA0B0;
                border-bottom: 1px solid #F3F5F9;
                padding-bottom: 2rem;
            }
        }

        .banner-box {
            width: 100%;
            padding-right: 3rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 2rem;
            &> :nth-child(n) {
                display: flex;
                align-items: center;

                i {
                    color: var(--blue);
                    font-size: 2rem;
                    font-weight: 700;
                }

                .item-num {
                    font-size: 16px;
                    color: #334681;
                    font-weight: 700;
                    margin-left: 1rem;
                }
            }
        }
    }
}

.soft-item:hover {
    transform: translateY(-2rem);
}
@media screen and (max-width:750px){
    .soft-box{
        justify-content: center;
    }
    .soft-item{
        width: 100% !important;
    }
}
</style>